import Accordion from '../../../../common/Accordion/Accordion'
import { Tabs, Tab } from '../../../../pages/docs/Docs/DocsTabs/DocsTabs'
import './DocsContent.scss'
import { ReactComponent as DownloadIcon } from '../../../../../assets/download.svg'
import Select from '../../../../common/Select/Select'
import Option from '../../../../common/Select/Option'
import { observable, runInAction } from 'mobx'
import { observer } from 'mobx-react'
import GlobalState from '../../../../../stores/GlobalState'
import ContentState from '../../../../../stores/ContentState'
import { useState } from 'react'

const DocsContent = observer(() => {
  const [tab, setTab] = useState(0)
  if (!ContentState.documents) return <></>
  return (
    <div className="docs">
      <div
        className="docs__content-title"
        dangerouslySetInnerHTML={{ __html: ContentState.documents[tab].title }}
      ></div>
      <div className="docs__content">
        <Tabs getTab={setTab}>
          {ContentState.documents?.map((tabContent, i) => {
            return (
              <Tab title={tabContent.title} key={i} link={tabContent.link}>
                <div
                  className="docs__content-title"
                  dangerouslySetInnerHTML={{ __html: tabContent.title }}
                ></div>
                {/* <div
                className="docs__content-text"
                dangerouslySetInnerHTML={{ __html: tabContent.subtitle }}
              ></div> */}
                <div className="docs__questions">
                  <Accordion items={tabContent.blocks} />
                </div>
                <a className="docs__btn" href={tabContent.butLink} download>
                  <DownloadIcon />
                  {tabContent.butText}
                </a>
              </Tab>
            )
          })}
        </Tabs>
      </div>
    </div>
  )
})
export default DocsContent
